var BaseStore = require('./BaseStore');
var Constants = require('../constants/Constants');
var Invocation = require('../api/Invocation');
var TokenConstants = require('../constants/Token');
var PaymentTokenStore = require('./PaymentTokenStore');

var BillingGroupStore = new BaseStore({
    defaultData: []
});

BillingGroupStore.getById = function(id) {
    return this._data.find(bg => bg.id == id);
};

BillingGroupStore.register(TokenConstants.NEW_PAYMENT_TOKEN_POST_SAVE, function (payload) {
    let {billingGroupDefaults, token} = payload.action;
    this._data.map(bg => {
        if (billingGroupDefaults.includes(bg.id)) {
            bg.payment_token = token.uuid;
        }
    });
    PaymentTokenStore.updateTokenUsageMap(this.get());
    this.emitChange();
});

BillingGroupStore.register(TokenConstants.UPDATE_GROUP, function (payload) {
    const { billingGroup, token } = payload.action;

    this._loading = true;
    this._savingToken = { billingGroup, tokenUuid: (token ? token.uuid : null) };

    const promise = Invocation.billing.updateToken(billingGroup, token);

    const originalValue = billingGroup.payment_token; // Proactively update billingGroup
    billingGroup.payment_token = token ? token.uuid : null;

    this.emitChange();

    promise
        .then(() => {
            this._savingToken = null;
            PaymentTokenStore.updateTokenUsageMap(this.get());
            this.finish()
        })
        .catch((err) => {
            billingGroup.payment_token = originalValue; // But revert that proactive change if necessary
            this.finishWithErrors(err)
        })
        .done();

    return true;
});

BillingGroupStore.register(Constants.api.GET_SERVICES, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;
        this.setData(action.response.body.client.billing_groups);

        return true;
    }

});

module.exports = BillingGroupStore;



// WEBPACK FOOTER //
// ./app/stores/BillingGroupStore.js